import { fetcher } from '@commenda/utils';

interface SetCommendaManagedComplianceResponse {
  success: boolean;
}

export async function setCommendaManagedCompliance(
  corporationId: number,
  { fiscalYear, enabled }: { fiscalYear: number; enabled: boolean }
): Promise<SetCommendaManagedComplianceResponse> {
  const res = await fetcher(`compliance/commenda-managed/${corporationId}`, {
    method: 'POST',
    body: { fiscalYear, enabled },
  });

  return { success: res.ok };
}
